import PlatformAPIEventType from "./PlatformAPIEventType";
import ProgressValue from "./ProgressValue";

export default class FocusTrackingController {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     */
    constructor(dispatcher) {
        this._dispatcher = dispatcher;

        this._elapsedTime = 0;
        this._initialized = false;

        this._handleFocusBound = this.handleFocus.bind(this);
        this._handleBlurBound = this.handleBlur.bind(this);
    }

    initialize() {
        if (this._initialized) {
            console.warn("FocusTrackingController already initialized! Ignoring request...");
            return;
        }

        window.addEventListener("focus", this._handleFocusBound);
        window.addEventListener("blur", this._handleBlurBound);

        this._initialized = true;
    }

    destroy() {
        if (!this._initialized) {
            console.warn("FocusTrackingController not initialized! Ignoring request...");
            return;
        }

        window.removeEventListener("focus", this._handleFocusBound);
        window.removeEventListener("blur", this._handleBlurBound);

        this._initialized = false;
    }

    handleFocus() {
        console.log(`[${FocusTrackingController.name}] Window focused.`);

        this._dispatcher.dispatch(PlatformAPIEventType.PROGRESS, {
            progressValue: ProgressValue.FOCUS,
            elapsedTime: Math.round(this._elapsedTime),
        });
    }

    handleBlur() {
        console.log(`[${FocusTrackingController.name}] Window blurred.`);

        this._dispatcher.dispatch(PlatformAPIEventType.PROGRESS, {
            progressValue: ProgressValue.BLUR,
            elapsedTime: Math.round(this._elapsedTime),
        });
    }

    /**
     * @param {number} value
     */
    set elapsedTime(value) {
        this._elapsedTime = value;
    }
}